import { createStyles, makeStyles } from '@material-ui/core';
import { variables } from 'src/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      width: '100%',
      height: 140,
      borderRadius: 8,
      padding: 16,
      backgroundColor: '#FAFAFA',
      boxShadow: 'none',

      '& .MuiCardHeader-root': {
        padding: 0,
      },

      '& .MuiCardHeader-title': {
        fontWeight: 400,
        fontSize: 14,
        marginBottom: 0,
        textAlign: 'left',
      },

      '& .MuiCardContent-root': {
        paddingLeft: 0,
      },
    },
    button: {
      padding: '5px 0 0 0',
    },
    content: {
      fontWeight: 600,
      fontSize: 18,
      color: variables.richBlack,
      textAlign: 'left',
    },
    padding: {
      marginTop: 36,
      paddingBottom: 0,
    },
    bottomContent: {
      textAlign: 'left',
      paddingRight: 4,
      paddingTop: 4,
      display: 'flex',
    },
    bottomContentItem: {
      borderRadius: 4,
      marginRight: 4,
      height: 19,
      paddingLeft: 4,
      paddingRight: 4,
      backgroundColor: variables.white,
      color: variables.black50,
    },
    selected: {
      border: '1px solid #030C21',
      backgroundColor: '#FFFFFF',
    },
    percentContent: {
      fontWeight: 600,
      fontSize: 16,
      color: variables.richBlack,
      textAlign: 'left',
      paddingRight: 5,
    },
    percentContentSecond: {
      fontWeight: 600,
      fontSize: 16,
      textAlign: 'left',
      paddingLeft: 5,
    },
    up: {
      backgroundColor: '#3BBB7A',
      color: variables.white,
    },
    down: {
      backgroundColor: '#FF8F94',
      color: variables.white,
    },
    doublePanelPadding: {
      textAlign: 'left',
      marginTop: 36,
      paddingBottom: 0,
    },
  }),
);
